package amazon.lastmile.inject

import com.karawek.core.auth.presenter.AuthenticationPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = AuthenticationPresenterFactory::class)
public interface ComKarawekCoreAuthPresenterAuthenticationPresenterFactory {
  @Provides
  @IntoSet
  public fun provideAuthenticationPresenterFactoryFactoryMultibinding(authenticationPresenterFactory: AuthenticationPresenterFactory): Presenter.Factory = authenticationPresenterFactory
}
